export default "__VITE_ASSET__7eWtwv1z__"